import axios from "axios";

// Use the current page origin so the frontend and backend share a domain in
// production (cresttorconstruction.com) and in preview (…preview.emergentagent.com).
// This avoids cross-site cookie + CORS problems: the auth cookie set by
// /api/auth/login is then first-party and is sent on subsequent requests.
// Falls back to the build-time env var for non-browser contexts (SSR, tests).
const BACKEND_URL =
  (typeof window !== "undefined" && window.location?.origin) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";
export const API_BASE = `${BACKEND_URL}/api`;

// Auth uses httpOnly cookies (set by the backend on /auth/login).
// We deliberately do NOT store the token in localStorage to avoid XSS exposure.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const fileUrl = (relative) => {
  if (!relative) return "";
  if (relative.startsWith("http")) return relative;
  return `${BACKEND_URL}${relative}`;
};

export default api;
